import React from 'react'
import { Col, Row } from 'reactstrap'
import styled from 'styled-components'
import { Event as EventModel } from '../../../../model/Event'
import DateTime from './DateTime/DateTime'
import Logo from './Logo/Logo'

const Wrapper = styled.div`
  line-height: 1;

  .main {
    font-size: 6.2rem;
    font-weight: bold;
  }

  .sub {
    font-size: 3rem;
    font-weight: bold;
    padding-left: 1rem;
  }
`

interface IProps {
  event: EventModel
  isPortraitOriented: boolean
  showLogo: boolean
}

const Information = ({ event, isPortraitOriented, showLogo }: IProps) => {
  const { fromDate, toDate, logoFilePath } = event

  return (
    <Wrapper>
      <Row className="h-100">
        <Col xs="12" sm={isPortraitOriented ? '12' : (showLogo ? '7' : '12')}>
          <DateTime fromDate={fromDate} toDate={toDate}/>
        </Col>
        <Col className="align-self-end" xs="12" sm={isPortraitOriented ? '12' : (showLogo ? '5' : '12')}>
          {showLogo && <Logo src={logoFilePath}/>}
        </Col>
      </Row>
    </Wrapper>
  )
}

export default Information
